// store/slices/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profilePictureUrl: localStorage.getItem("profilePicture") || "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setProfilePictureUrl: (state, action) => {
      state.profilePictureUrl = action.payload || "";
      // персистим, чтобы было после перезагрузки
      localStorage.setItem("profilePicture", state.profilePictureUrl);
    },
  },
});

export const { setProfilePictureUrl } = userSlice.actions;
export default userSlice.reducer;
